export function AboutIcon() {
    return(
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 9H11L14 12V15H2V12L5 9Z" fill="var(--ranColor)"/>
            <path d="M11 4C11 5.65685 9.65685 7 8 7C6.34315 7 5 5.65685 5 4C5 2.34315 6.34315 1 8 1C9.65685 1 11 2.34315 11 4Z" fill="var(--ranColor)"/>
        </svg>
    )
}

export function ArrowDownIcon() {
    return(
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 9L15 9V10L9 16H7L1 10L1 9H6V0L10 4.76995e-08V9Z" fill="var(--ranColor)"/>
        </svg>
    )
}

export function ArrowLeftIcon() {
    return(
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 10L7 15H6L0 9V7L6 1H7L7 6H16V10H7Z" fill="var(--ranColor)"/>
        </svg>
    )
}

export function ArrowRightIcon() {
    return(
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 6V1L10 1L16 7V9L10 15H9V10H3.49691e-07L0 6L9 6Z" fill="var(--ranColor)"/>
        </svg>
    )
}

export function CloseIcon() {
    return(
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.17172 7.99991L0.585938 3.41412L3.41436 0.585693L8.00015 5.17148L12.5859 0.585693L15.4144 3.41412L10.8286 7.99991L15.4144 12.5857L12.5859 15.4141L8.00015 10.8283L3.41436 15.4141L0.585938 12.5857L5.17172 7.99991Z" fill="var(--ranColor)"/>
        </svg>
    )
}

export function EmailIcon() {
    return(
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M4.58579 0H11.4142L16 4.58579V10.4142L14.4142 12H11.5858L10.6138 11.028C9.91331 11.633 8.99838 12 8 12C5.79086 12 4 10.2091 4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8V9.58579L12.4142 10H13.5858L14 9.58579V5.41421L10.5858 2H5.41421L2 5.41421V10.5858L5.41421 14H11V16H4.58579L0 11.4142V4.58579L4.58579 0ZM10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10C8.51288 10 8.97858 9.80826 9.33309 9.49097C9.74385 9.12333 10 8.59224 10 8Z" fill="var(--ranColor)"/>
        </svg>
    )
}

export function FlagIcon() {
    return(
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 1H4V15H2V1Z" fill="var(--ranColor)"/>
            <path d="M6 1H10L12 3H15V11H12L10 9H6V1Z" fill="var(--ranColor)"/>
        </svg>
    )
}

export function GitHubIcon() {
    return(
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 6C14.6569 6 16 4.65685 16 3C16 1.34315 14.6569 0 13 0C11.6938 0 10.5825 0.834808 10.1707 2H7.58579L4.29342 5.29237C3.90178 5.10495 3.46315 5 3 5C1.34315 5 0 6.34315 0 8C0 9.65685 1.34315 11 3 11C3.46315 11 3.90178 10.895 4.29342 10.7076L7.58579 14H10.1707C10.5825 15.1652 11.6938 16 13 16C14.6569 16 16 14.6569 16 13C16 11.3431 14.6569 10 13 10C11.6938 10 10.5825 10.8348 10.1707 12H8.41421L5.70763 9.29342C5.89505 8.90178 6 8.46315 6 8C6 7.53685 5.89505 7.09822 5.70763 6.70658L8.41421 4H10.1707C10.5825 5.16519 11.6938 6 13 6Z" fill="var(--ranColor)"/>
        </svg>
    )
}

export function HtmlCloseIcon() {
    return(
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8 7.82852L3.58579 3.41431L6.41421 0.585881L12 6.17167L12 9.82852L6.41421 15.4143L3.58579 12.5859L8 8.17167L8 7.82852Z" fill="var(--ranColor)"/>
        </svg>
    )
}

export function HtmlOpenIcon() {
    return(
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8 8.17148L12.4142 12.5857L9.58579 15.4141L4 9.82833V6.17148L9.58579 0.585693L12.4142 3.41412L8 7.82833V8.17148Z" fill="var(--ranColor)"/>
        </svg>
    )
}

export function LinkIcon() {
    return(
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M10.4142 2L7.20711 5.20711L5.79289 3.79289L9.58579 2.98023e-07L13.4142 0L16 2.58579L16 6.41421L12.2071 10.2071L10.7929 8.79289L14 5.58579L14 3.41421L12.5858 2L10.4142 2ZM11.7071 5.70711L5.70711 11.7071L4.29289 10.2929L10.2929 4.29289L11.7071 5.70711ZM2 10.4142L5.20711 7.20711L3.79289 5.79289L0 9.58579V13.4142L2.58579 16H6.41421L10.2071 12.2071L8.79289 10.7929L5.58579 14H3.41421L2 12.5858V10.4142Z" fill="var(--ranColor)"/>
        </svg>
    )
}

export function ExternalLinkIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 1L15 2L15 7L14 8L11.7071 5.70711L7.70711 9.70711L6.29289 8.29289L10.2929 4.29289L8 2L9 1H14Z" fill="var(--ranColor)"/>
            <path d="M1 2V15H14V10H12V13H3V4H6V2H1Z" fill="var(--ranColor)"/>
        </svg>
    )
}

export function LinkedInIcon() {
    return(
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 4.5C8 5.88071 6.88071 7 5.5 7C4.11929 7 3 5.88071 3 4.5C3 3.11929 4.11929 2 5.5 2C6.88071 2 8 3.11929 8 4.5Z" fill="var(--ranColor)"/>
            <path d="M2 9L0 11V14H8V9H2Z" fill="var(--ranColor)"/>
            <path d="M16 11L14 9H10V14H16V11Z" fill="var(--ranColor)"/>
            <path d="M12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5C10 6.10457 10.8954 7 12 7Z" fill="var(--ranColor)"/>
        </svg>
    )
}

export function MenuIcon() {
    return(
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 2H15V4H1V2Z" fill="var(--ranColor)"/>
            <path d="M1 7H15V9H1V7Z" fill="var(--ranColor)"/>
            <path d="M15 12H1V14H15V12Z" fill="var(--ranColor)"/>
        </svg>
    )
}

export function SendIcon() {
    return(
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 1H4L15 7V9L4 15H2L3 9H10V7H3L2 1Z" fill="var(--ranColor)"/>
        </svg>
    )
}

export function StarIcon() {
    return(
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.00001 0H9.00001L10.232 4.92794L15.2994 4.57681L15.9175 6.47892L11.6114 9.17342L13.5113 13.8843L11.8933 15.0599L8.00003 11.7973L4.10677 15.0599L2.48873 13.8843L4.3886 9.17344L0.0825195 6.47892L0.700554 4.57681L5.76802 4.92794L7.00001 0Z" fill="var(--ranColor)"/>
        </svg>
    )
}

export function WorkIcon() {
    return(
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.29289 3.70711L1 11V15H5L12.2929 7.70711L8.29289 3.70711Z" fill="var(--ranColor)"/>
            <path d="M9.70711 2.29289L13.7071 6.29289L15.1716 4.82843C15.702 4.29799 16 3.57857 16 2.82843C16 1.26633 14.7337 0 13.1716 0C12.4214 0 11.702 0.297995 11.1716 0.828428L9.70711 2.29289Z" fill="var(--ranColor)"/>
        </svg>
    )
}